import { apiGet, apiPost } from '@/utils/httpClient'

export const userApi = {
    getUserInfo() {
        return apiGet('user/data');
    },

    setInterfaceLanguage(newLanguage: any) {
        const update = {
            newLanguage: newLanguage
        };

        return apiPost('user/setInterfaceLanguage', update);
    },

    getUserSubscription() {
        return apiGet('user/subscription');
    }
}
